import { TrilhaDeAuditoriaTabela } from "./trilha_de_auditoria_tabela.model";

export class TrilhaDeAuditoria {
    alterado_por: string;
    id: number;
    id_finalidade: number;
    data_inclusao: Date;
    data_alteracao: Date;
    id_sistema: number;
    id_status: number;
    incluido_por: string;
    trilha_de_auditoria_tabela: TrilhaDeAuditoriaTabela[];
}



// WEBPACK FOOTER //
// ./src/app/entity/trilha_de_auditoria.model.ts